import { render, staticRenderFns } from "./PedidosPromociosContratos.vue?vue&type=template&id=f072b4e2"
import script from "./PedidosPromociosContratos.vue?vue&type=script&lang=js"
export * from "./PedidosPromociosContratos.vue?vue&type=script&lang=js"
import style0 from "./PedidosPromociosContratos.vue?vue&type=style&index=0&id=f072b4e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports